<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalconfirmDelete" ref="modalconfirmDelete" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>Name:</b> {{ relativeDelete.name }}</p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDelete">Confirm</b-button>
          <b-button variant="secondary" @click="hideModalDelete">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalRelative" ref="modalRelative" size="lg" :title="(newRelative) ? 'Add new relative' : 'Edit relative'">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
              <label>Name <span v-if="checkLabelRequired('name')" class="text-danger">*</span></label>   
              <div class="input-group"> 
                <b-form-input id="name-input" v-model="relative.name" :state="$v.relative.name.$dirty ? !$v.relative.name.$error : null"></b-form-input>
              </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
              <label>Relative <span v-if="checkLabelRequired('relativeId')" class="text-danger">*</span></label>   
              <div class="input-group"> 
                <b-form-select v-model="relative.relativeId" :state="$v.relative.relativeId.$dirty ? !$v.relative.relativeId.$error : null" :options="relativeOptions" value-field="id" text-field="description"></b-form-select>
              </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
              <label>Agency, Fund or Programme <span v-if="checkLabelRequired('agencyFundProgramme')" class="text-danger">*</span></label>   
              <div class="input-group"> 
                <b-form-input id="name-input" v-model="relative.agencyFundProgramme" :state="$v.relative.agencyFundProgramme.$dirty ? !$v.relative.agencyFundProgramme.$error : null" max-length="250"></b-form-input>
              </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="UN Relative" label-for="name-input">
            <b-form-checkbox v-model="relative.unRelative" value="true" @input="onClickUNRelative"></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Office Relative" label-for="name-input">
            <b-form-checkbox v-model="relative.officeRelative" value="true" @input="onClickOfficeRelative"></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveRelative">Save</b-button>
          <b-button variant="secondary" @click="hideModal">Close</b-button>
      </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title">UN Information</h5>
      <div class="row">
        <div class="form-group col-md-4 col-xs-12">
          <label for="workedUnSystem">Have you ever worked to the UN System? <span v-if="checkLabelRequired('workedUnSystem')" class="text-danger">*</span>
          <br><small><i>This applies for those who had a contract within the UN System.</i></small>
          </label>
          <div class="input-group"> 
            <b-form-radio-group id="workedUnSystem" v-model="unInformation.workedUnSystem" :state="$v.unInformation.workedUnSystem.$dirty ? !$v.unInformation.workedUnSystem.$error : null" type="text">
              <b-form-radio name="workedUnSystem" value="true">Yes</b-form-radio>
              <b-form-radio class="ml-2" name="workedUnSystem" value="false">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <div v-if="unInformation.workedUnSystem === 'true' || unInformation.workedUnSystem === true" class="input-group mt-2"> 
            <b-form-input id="name-input" v-model="unInformation.workedUnSystemAgencyName" :state="$v.unInformation.workedUnSystemAgencyName.$dirty ? !$v.unInformation.workedUnSystemAgencyName.$error : null" placeholder="Inform name of Agency"></b-form-input>
          </div>
        </div>
        <div class="form-group col-md-4 col-xs-12">
          <label for="formerUnEmployee">Are you a former UN employee? <span v-if="checkLabelRequired('formerUnEmployee')" class="text-danger">*</span>
          <br><small><i>This applies for those who had a Staff contract within the UN System.</i></small>
          </label>
          <div class="input-group"> 
            <b-form-radio-group id="formerUnEmployee" v-model="unInformation.formerUnEmployee" :state="$v.unInformation.formerUnEmployee.$dirty ? !$v.unInformation.formerUnEmployee.$error : null">
              <b-form-radio name="formerUnEmployee" value="true">Yes</b-form-radio>
              <b-form-radio class="ml-2" name="formerUnEmployee" value="false">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <div v-if="unInformation.formerUnEmployee === 'true' || unInformation.formerUnEmployee === true" class="input-group mt-2"> 
            <b-form-input id="name-input" v-model="unInformation.formerUnEmployeeAgencyName" :state="$v.unInformation.formerUnEmployeeAgencyName.$dirty ? !$v.unInformation.formerUnEmployeeAgencyName.$error : null" placeholder="Inform name of Agency"></b-form-input>
          </div>
        </div>
        <div class="form-group col-md-4 col-xs-12">
          <label for="unSystemRetiree">Are you a UN System retiree? <span v-if="checkLabelRequired('unSystemRetiree')" class="text-danger">*</span>
          <br><small><i>This applies for those who retired only.</i></small>
          </label>
          <div class="input-group"> 
            <b-form-radio-group id="unSystemRetiree" v-model="unInformation.unSystemRetiree" :state="$v.unInformation.unSystemRetiree.$dirty ? !$v.unInformation.unSystemRetiree.$error : null">
              <b-form-radio name="lgbtqia" value="true">Yes</b-form-radio>
              <b-form-radio class="ml-2" name="lgbtqia" value="false">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <div v-if="unInformation.unSystemRetiree === 'true' || unInformation.unSystemRetiree === true" class="input-group mt-2"> 
            <b-form-input id="name-input" v-model="unInformation.unSystemRetireeAgencyName" :state="$v.unInformation.unSystemRetireeAgencyName.$dirty ? !$v.unInformation.unSystemRetireeAgencyName.$error : null" placeholder="Inform name of Agency"></b-form-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-button variant="primary" @click="saveUnInformation">Save UN Information</b-button>
        </div>
      </div>
    </div> 
    <div class="card-body">
      <h5 class="card-title">Relatives - please indicate any family member you have working for the United Nations</h5>
      <div class="row">
        <div class="col-md-12 mt-2">
          <b-table hover :items="relativeItems" :fields="relativeFields">
            <template v-slot:cell(unRelative)="row">
              {{ row.item.unRelative | formatYesNo }}
            </template>
            <template v-slot:cell(officeRelative)="row">
              {{ row.item.officeRelative | formatYesNo }}
            </template>
            <template v-slot:cell(edit)="row">
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" @click="modalEditRelative(row.item.id)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-1" @click="confirmDeleteRelative(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
          </b-table>
        </div>
        <div class="col-md-12">
          <b-button variant="primary" @click="modalAddRelative">Add relative</b-button>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CandidateId: this.id,
      relativeFields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'agencyFundProgramme',
          label: 'Agency, Fund or Programme'
        },
        {
          key: 'relative.description',
          label: 'Relative'
        },
        {
          key: 'unRelative',
          label: 'UN Relative'
        },
        {
          key: 'officeRelative',
          label: 'Office Relative'
        },
        {
          key: 'edit',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ],
      unInformation: {
        workedUnSystemAgencyId: null,
        formerUnEmployee: null,
        unSystemRetiree: null
      },
      relativeItems: [],
      relative: {},
      relativeOptions: [],
      newRelative: false,
      relativeDelete: {},
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      requiredFields: [],
      agencies: []
    }
  },
  validations() {
    return {
      relative: {
        name: this.checkDynamicRequired('name'),
        relativeId: this.checkDynamicRequired('relativeId'),
        agencyFundProgramme: this.checkDynamicRequired('agencyFundProgramme'),
      },
      unInformation: {
        workedUnSystem: this.checkDynamicRequired('workedUnSystem'),
        workedUnSystemAgencyName: (this.unInformation.workedUnSystem === true || this.unInformation.workedUnSystem === 'true') ? this.checkDynamicRequired('workedUnSystem') : {},
        formerUnEmployee: this.checkDynamicRequired('formerUnEmployee'),
        formerUnEmployeeAgencyName: (this.unInformation.formerUnEmployee === true || this.unInformation.formerUnEmployee === 'true') ? this.checkDynamicRequired('formerUnEmployee') : {},
        unSystemRetiree: this.checkDynamicRequired('unSystemRetiree'),
        unSystemRetireeAgencyName: (this.unInformation.unSystemRetiree === true || this.unInformation.unSystemRetiree === 'true') ? this.checkDynamicRequired('unSystemRetiree') : {}
      }
    }
  },
  watch: {
    'unInformation.workedUnSystem': {
      handler: function (value) {
        if (value === 'false' || value === false) {
          this.unInformation.workedUnSystemAgencyName = ''
        }
      }
    },
    'unInformation.formerUnEmployee': {
      handler: function (value) {
        if (value === 'false' || value === false) {
          this.unInformation.formerUnEmployeeAgencyName = ''
        }
      }
    },
    'unInformation.unSystemRetiree': {
      handler: function (value) {
        if (value === 'false' || value === false) {
          this.unInformation.unSystemRetireeAgencyName = ''
        }
      }
    }
  },
  created () {
    this.loadRequiredFields()
    this.loadRelative()
    this.loadCandidateRelative()
    this.loadAgencies()
    this.loadUnInformation()
  },
  methods: {
    ...authMethods,
    loadUnInformation () {
      axios.get(`${appConfig.apiUrl}curriculum/${this.id}/simple`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.unInformation = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error})
      })
    },
    loadAgencies () {
      axios.get(appConfig.apiUrl + 'agency/combo',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.agencies = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error})
      })
    },
    loadRequiredFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.agency.id}/only/relative`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = response.data
      })
    },
    checkDynamicRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return { required }
      }
      return {}
    },
    checkLabelRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return true
      }
      return false
    },
    hideModalDelete() {
      this.$refs['modalconfirmDelete'].hide()
    },
    hideModal() {
      this.$refs['modalRelative'].hide()
      this.$v.relative.$reset()
    },
    loadRelative() {
      axios.get(appConfig.apiUrl + 'relative',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.relativeOptions = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    loadCandidateRelative() {
      axios.get(appConfig.apiUrl + 'relative/curriculum/' + this.id,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.relativeItems = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    modalAddRelative() {
      this.newRelative = true
      this.relative = {
         curriculumId: this.id
      }
      this.$refs['modalRelative'].show()
    },
    modalEditRelative(relativeId) {
      this.newRelative = false
      this.relative = {}
      axios.get(appConfig.apiUrl + 'relative/id/' + relativeId,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.relative = response.data
        this.$refs['modalRelative'].show()
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    saveRelative() {
      this.$v.relative.$touch()
      if (this.$v.relative.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      this.isLoading = true
      axios.post(appConfig.apiUrl + 'relative/save',
        qs.stringify(this.relative),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
          this.loadCandidateRelative()
          this.$emit('reload-curriculum')
          this.hideModal()
        })
    },
    saveUnInformation () {
      this.$v.unInformation.$touch()
      if (this.$v.unInformation.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }
      
      this.isLoading = true
      axios.post(appConfig.apiUrl + 'curriculum/un-information',
        qs.stringify(this.unInformation),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
          this.loadCandidateRelative()
          this.$emit('reload-curriculum')
          this.hideModal()
        })
    },
    confirmDeleteRelative(relative) {
      this.relativeDelete = relative
      this.$refs['modalconfirmDelete'].show()
    },
    confirmDelete () {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `relative/${this.relativeDelete.id}`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadCandidateRelative()
          this.isLoading = false
          this.$emit('reload-curriculum')
          this.hideModalDelete()
        })
    },
    onClickUNRelative(){
      if(this.relative.unRelative){
        this.relative.officeRelative = false
      }      
    },
    onClickOfficeRelative(){
      if(this.relative.officeRelative){
        this.relative.unRelative = false
      }
      
    }
  }
}
</script>

<style>

</style>
